export default "__VITE_ASSET__2031ca4a__"